import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class EventService {

    private loadingDataStartedSource = new Subject<void>();
    loadingDataStarted = this.loadingDataStartedSource.asObservable();
    private loadingDataCompleteSource = new Subject<void>();
    loadingDataComplete = this.loadingDataCompleteSource.asObservable();

    constructor(
        private toastr: ToastrService,
        private translate: TranslateService) { }

    startLoadingData() {
        this.loadingDataStartedSource.next();
    }

    completeLoadingData() {
        this.loadingDataCompleteSource.next();
    }

    async successMessage(option: number, text: string = '') {
        switch (option) {
            case 1:
                const newSuccess = await this.onTranslate("common.catMessage.newSuccess");
                this.toastr.success(newSuccess);
                break;
            case 2:
                const editSuceess = await this.onTranslate(text || "common.catMessage.editSuccess");
                this.toastr.success(editSuceess);
                break;
            case 3:
                this.toastr.success(text);
                break;
            default:
                let msg = await this.onTranslate(text);
                this.toastr.success(msg);
                break;
        }
    }

    async errorMessage(option?: number, message?: string, aditionalInfo?: string) {
        const formError = await this.onTranslate("common.catMessage.formError");

        switch (option) {
            case 1:
                const serverError = await this.onTranslate("common.catMessage.serverError");
                this.toastr.error(serverError);
                break;
            case 2:
                this.toastr.error(formError);
                break;
            case 3:
                const formErrorDefault = await this.onTranslate(message);

                if (aditionalInfo) {
                    const aditionalInfoData = await this.onTranslate(aditionalInfo);
                    this.toastr.error(formErrorDefault + (aditionalInfo ? `: ${aditionalInfoData}` : ''));
                }
                else
                    this.toastr.error(formErrorDefault);

                break;
            default:
                let msg = await this.onTranslate(message);
                this.toastr.error(msg ? msg : formError);
                break;
        }
    }

    async infoMessage(message: string) {
        const msg = await this.onTranslate(message);
        this.toastr.info(msg);
    }

    async warningMessage(message: string) {
        const msg = await this.onTranslate(message);
        this.toastr.warning(msg);
    }

    async onTranslate(key: string): Promise<string> {
        return await new Promise((resolve: any) => {
            this.translate.get(key).subscribe((res: string) => {
                resolve(res);
            });
        })
    }
}
